import { Card } from '@plato/ui-legacy/components/ui/card';
import { Skeleton } from '@plato/ui-legacy/components/ui/skeleton';

// Individual card skeleton component
function EventCardSkeleton() {
    return (
        <Card className="p-0 bg-white">
            <div className="flex flex-col gap-2 px-3 py-2">
                {/* Customer name skeleton */}
                <Skeleton className="h-4 w-3/4" />

                {/* Description skeleton */}
                <Skeleton className="h-4 w-5/6" />
            </div>

            <hr className="border-neutral-100" />

            <div className="px-3 py-2 flex flex-wrap gap-4">
                {/* InfoTag skeletons - time, location, recurrence, tasks */}
                <Skeleton className="h-5 w-28 rounded-full" />
                <Skeleton className="h-5 w-32 rounded-full" />
                <Skeleton className="h-5 w-24 rounded-full" />
                <Skeleton className="h-5 w-36 rounded-full" />
            </div>
        </Card>
    );
}

type EventsLoadingStateProps = {
    count?: number;
};

export function EventsLoadingState({ count = 3 }: EventsLoadingStateProps) {
    return (
        <div className="space-y-4">
            {Array.from({ length: count }).map((_, index) => (
                <EventCardSkeleton key={index} />
            ))}
        </div>
    );
}
